import { Component, inject } from '@angular/core';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { ButtonComponent } from '@components/buttons/button/button.component';
import { environment } from '@shared/envs/env';
import { staticImages } from '@shared/helper/configs';

@Component({
  selector: 'app-pwa-updater-dialog',
  imports: [MatDialogModule, ButtonComponent],
  templateUrl: './pwa-updater-dialog.component.html',
  styleUrl: './pwa-updater-dialog.component.scss',
})
export class PwaUpdaterDialogComponent {
  private dialogRef = inject(MatDialogRef<PwaUpdaterDialogComponent>);
  version = environment.version;
  staticImages = staticImages;

  ngOnInit() {
    this.dialogRef.addPanelClass('pwa-updater-dialog');
    this.dialogRef.disableClose = true;
  }

  submit() {
    this.dialogRef.close(true);
  }
}
